function Greedy(props) {
  return <div style={{ flexGrow: '13' }} {...props} />;
}

export { Greedy };
